<template>
    <div class="flex relative">
        <side-bar />
        <slot />
    </div>
</template>

<script>
import SideBar from './includes/SideBar'
export default {
    components: {
        SideBar,
    },
}
</script>

<style></style>
